export function genrateBroadlyHeader(data:any,brand:any){
let overallRating  =  data[0]?.overallRating+'/5';
sessionStorage.setItem('overallRating',overallRating);
if(overallRating.toString().indexOf('.') === -1){overallRating = overallRating + '.0'}
return `<div class ="concept-rating-display hydrated">
            <div class="logo-rating">
                 <div class="concept-logo hydrated">
                    <img src="${brand.image}" alt="${brand.name}">
                 </div>
                <div class="ratings-wrapper">
                        <span id="ratingText" class="ratings-text ">${overallRating}</span>
                        <div id="ratingsInfo" class="ratings-info">
                            <p class="rating-number mb-0">${data[0]?.grandTotal.toLocaleString() + ' Ratings'} </p>
                            <span class="rating-number">|</span>
                        </div>
                        <div id="starsDisplay" class="rating stars-container">
                            <span class="star full mr-1">★</span>
                            <span class="star full mr-1">★</span>
                            <span class="star full mr-1">★</span>
                            <span class="star full mr-1">★</span>
                            <span class="star full mr-1">★</span>
                        </div>
                        <div class="relative">
                            <div class="action-container">
                                <span id="popoverBtn" class="arrow-btn bg-white">
                                    <svg id="downArrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29303 7.29308C5.48056 7.10561 5.73487 7.00029 6.00003 7.00029C6.26519 7.00029 6.5195 7.10561 6.70703 7.29308L10 10.5861L13.293 7.29308C13.3853 7.19757 13.4956 7.12139 13.6176 7.06898C13.7396 7.01657 13.8709 6.98898 14.0036 6.98783C14.1364 6.98668 14.2681 7.01198 14.391 7.06226C14.5139 7.11254 14.6255 7.18679 14.7194 7.28069C14.8133 7.37458 14.8876 7.48623 14.9379 7.60913C14.9881 7.73202 15.0134 7.8637 15.0123 7.99648C15.0111 8.12926 14.9835 8.26048 14.9311 8.38249C14.8787 8.50449 14.8025 8.61483 14.707 8.70708L10.707 12.7071C10.5195 12.8946 10.2652 12.9999 10 12.9999C9.73487 12.9999 9.48056 12.8946 9.29303 12.7071L5.29303 8.70708C5.10556 8.51955 5.00024 8.26525 5.00024 8.00008C5.00024 7.73492 5.10556 7.48061 5.29303 7.29308Z" fill="#111928"></path>
                                    </svg>
                                    <svg id="upArrow" class="hidden h-5 w-5" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7072 12.7069C14.5197 12.8944 14.2654 12.9997 14.0002 12.9997C13.735 12.9997 13.4807 12.8944 13.2932 12.7069L10.0002 9.41392L6.70721 12.7069C6.61497 12.8024 6.50462 12.8786 6.38262 12.931C6.26061 12.9834 6.12939 13.011 5.99661 13.0122C5.86384 13.0133 5.73216 12.988 5.60926 12.9377C5.48636 12.8875 5.37471 12.8132 5.28082 12.7193C5.18693 12.6254 5.11267 12.5138 5.06239 12.3909C5.01211 12.268 4.98681 12.1363 4.98796 12.0035C4.98912 11.8707 5.0167 11.7395 5.06911 11.6175C5.12152 11.4955 5.1977 11.3852 5.29321 11.2929L9.29321 7.29292C9.48074 7.10545 9.73505 7.00013 10.0002 7.00013C10.2654 7.00013 10.5197 7.10545 10.7072 7.29292L14.7072 11.2929C14.8947 11.4804 15 11.7348 15 11.9999C15 12.2651 14.8947 12.5194 14.7072 12.7069Z" fill="#111928"></path>
                                    </svg>
                                </span>
                                <span id="resetLink" class="hidden ">Reset</span>
                            </div>
                        </div>
            
                        <!-- popover -->
                        <div data-popover="" id="popover" role="tooltip" class="ratings-popover hidden">
                            <form id="ratingForm">
                                <div class="ratingFormdiv">
                                    <label class="ratingLabel">
                                        <input type="radio" name="rating" value="5" class="form-radio">
                                        <div id="starsContainer" class="rating stars-Container">
                                            <span class="star full mr-1">★</span>
                                            <span class="star full mr-1">★</span>
                                            <span class="star full mr-1">★</span>
                                            <span class="star full mr-1">★</span>
                                            <span class="star full mr-1">★</span>
                                        </div>
                                    </label>
                                    <label class="ratingLabel">
                                        <input type="radio" name="rating" value="4" class="form-radio">
                                        <div class="rating">
                                            <span class="star full mr-1">★</span>
                                            <span class="star full mr-1">★</span>
                                            <span class="star full mr-1">★</span>
                                            <span class="star full mr-1">★</span>
                                        </div>
                                    </label>
                                    <label class="ratingLabel">
                                        <input type="radio" name="rating" value="3" class="form-radio">
                                        <div class="rating">
                                            <span class="star full mr-1">★</span>
                                            <span class="star full mr-1">★</span>
                                            <span class="star full mr-1">★</span>
                                        </div>
                                    </label>
                                    <label class="ratingLabel">
                                        <input type="radio" name="rating" value="2" class="form-radio">
                                        <div class="rating">
                                            <span class="star full mr-1">★</span>
                                            <span class="star full mr-1">★</span>
            
                                        </div>
                                    </label>
                                    <label class="ratingLabel">
                                        <input type="radio" name="rating" value="1" class="form-radio">
                                        <div class="rating">
                                            <span class="star full mr-1">★</span>
            
                                        </div>
                                    </label>
                                </div>
                            </form>
                            <div data-popper-arrow=""></div>
                        </div>
                        <!-- popover end -->
                    </div>
            </div>
            <div class="schedule">
                <div class="schedule-now-cta hydrated" data-id="schedule-now-cta">
                    <a class="phone-number call-icon" href="tel:${brand.phone}">
                       ${brand.phone}
                    </a>
                    <div class="call-label">
                        <slot-fb name="call-label" hidden=""> Call Us 24/7 </slot-fb>
                        <div slot="call-label">
                            <div slot="call-label">
                                All Neighborly services are covered by the 
                                <a href="/en-us/neighborly-done-right-promise">Neighborly Done Right Promise.</a>
                            </div>
                        </div>
                    </div>
                    <button class="schedule-now-btn review-scheduler-btn schedule_btn" data-toggle="modal" data-target="#js-schedulerDialog">Schedule Now</button>
                </div>
            </div>
        </div>
        <section class="no-review-section hidden">
        </section>
        `
}
